const c = {
  name: "Kangaroo",
  dimensions: { width: 34, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 34 40" style="enable-background:new 0 0 34 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M14,25.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C12.8,24.7,13.3,25.2,14,25.2z"
			/>
		<path class="st0" d="M20,25.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C18.8,24.7,19.3,25.2,20,25.2z"
			/>
		<path class="st0" d="M32.2,0.4c0.8,0.5,1.3,1.2,1.6,2.3h0c0.8,2.9-0.5,8-3.4,12.9c-1.2,2.1-2.6,3.9-4,5.5c1,2.3,1.6,4.8,1.6,6.9
			c0,4.4-2.6,8.4-6.6,10.1C20.2,39.3,18.6,40,17,40s-3.2-0.7-4.3-1.9C8.6,36.3,6,32.4,6,28c0-2.1,0.6-4.6,1.6-6.9
			c-1.5-1.6-2.8-3.4-4-5.5c-2.8-4.9-4.2-10-3.4-12.9c0.3-1,0.8-1.8,1.6-2.3C3.4-0.5,5.6,0.1,8,2c2.2,1.7,4.3,4.4,6.1,7.5
			c0.7,1.2,1.3,2.4,1.8,3.6C16.3,13,16.6,13,17,13c0.4,0,0.8,0,1.1,0.1c0.5-1.2,1.1-2.4,1.8-3.6c1.8-3.1,4-5.8,6.1-7.5
			C28.4,0.1,30.6-0.5,32.2,0.4z M2.2,3.2c-0.5,2,0.2,6.3,3.2,11.4c1,1.7,2.1,3.3,3.3,4.6c1.4-2.4,3.2-4.4,5.4-5.5
			c-0.4-1.1-1-2.1-1.6-3.2c-1.7-2.9-3.7-5.4-5.6-6.9C5.1,2.3,3.6,1.7,2.8,2.1C2.5,2.3,2.3,2.7,2.2,3.2z M15,31c0,0.6,1,2,2,2
			s2-1.4,2-2c0-0.4-0.8-1-2-1S15,30.6,15,31z M20.2,36.4l0.2-0.1h0c3.4-1.4,5.6-4.7,5.6-8.3c0-5-4.1-13-9-13s-9,8-9,13
			c0,3.7,2.2,6.9,5.6,8.3l0.2,0.1l0.2,0.2c0.5,0.6,1.2,1,2,1.2v-3c-1.8-0.6-3-2.5-3-3.8c0-1.7,1.8-3,4-3s4,1.3,4,3
			c0,1.3-1.2,3.3-3,3.8v3c0.8-0.2,1.5-0.6,2-1.2L20.2,36.4z M25.4,19.2c1.2-1.3,2.3-2.9,3.3-4.6c2.9-5.1,3.7-9.4,3.2-11.4
			c-0.1-0.5-0.4-0.9-0.7-1.1c-0.8-0.4-2.2,0.1-3.9,1.4c-2,1.6-4,4-5.6,6.9c-0.6,1.1-1.2,2.2-1.6,3.2C22.2,14.7,24,16.8,25.4,19.2z"
			/>
	</g>
</g>
</svg>
  `
};
export {
  c as Kangaroo
};
